<!-- 智慧农业云平台 - 根组件 -->
<!-- 所属公司：河南农博联信息技术有限公司 -->
<!-- 开发人员：王健 -->
<!-- 提交时间：2025年 -->
<template>
  <div id="app" :class="theme">
    <router-view />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'App',
  computed: {
    ...mapGetters(['theme'])
  }
}
</script>

<style>
/* 全局样式重置 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body, #app {
  width: 100%;
  height: 100%;
  overflow: hidden;
  font-family: 'Microsoft YaHei', 'PingFang SC', sans-serif;
}

/* 暗色主题 */
.dark {
  --bg-primary: #0a1934;
  --bg-secondary: #0d2147;
  --bg-card: rgba(13, 33, 71, 0.85);
  --text-primary: #e0e6ed;
  --text-secondary: #8b9dc3;
  --border-color: #1e3a5f;
  --accent-color: #00d4ff;
  --accent-gradient: linear-gradient(135deg, #00d4ff, #0099ff);
}

/* 浅色主题 */
.light {
  --bg-primary: #f0f4f8;
  --bg-secondary: #ffffff;
  --bg-card: rgba(255, 255, 255, 0.95);
  --text-primary: #2c3e50;
  --text-secondary: #7f8c9b;
  --border-color: #dce4ec;
  --accent-color: #1976d2;
  --accent-gradient: linear-gradient(135deg, #1976d2, #42a5f5);
}

#app {
  background: var(--bg-primary);
  color: var(--text-primary);
}

/* Element UI 大屏样式覆盖 */
.dark .el-table {
  background-color: transparent !important;
  color: var(--text-primary) !important;
}

.dark .el-table th.el-table__cell {
  background-color: rgba(0, 212, 255, 0.1) !important;
  color: var(--accent-color) !important;
  border-bottom: 1px solid var(--border-color) !important;
}

.dark .el-table td.el-table__cell {
  border-bottom: 1px solid var(--border-color) !important;
  background-color: transparent !important;
}

.dark .el-table tr:hover > td {
  background-color: rgba(0, 212, 255, 0.05) !important;
}

.dark .el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
  background-color: rgba(0, 212, 255, 0.05) !important;
}

/* 滚动条样式 */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

.dark ::-webkit-scrollbar-thumb {
  background: rgba(0, 212, 255, 0.3);
  border-radius: 3px;
}

.light ::-webkit-scrollbar-thumb {
  background: rgba(25, 118, 210, 0.3);
  border-radius: 3px;
}

::-webkit-scrollbar-track {
  background: transparent;
}
</style>
